export default __webpack_public_path__ + "static/media/background-prod.e9e7f264.png";